














import {Component, Prop, Vue} from "vue-property-decorator";
import ContestList from '../../../shared/components/ContestList.vue';
import ContestListLike from '../../../shared/models/ContestList';
import contestService from '../services/ContestService';
import LoadingContestList from '@/shared/components/ui/LoadingContestList.vue';
import { IContestPagination } from "@/shared/types";

@Component({
    components: {
        ContestList,
        LoadingContestList
    },
})
export default class History extends Vue {
    @Prop() userId !: string;

    private list: ContestListLike = {
        title: "Finished contests",
        description: "",
        items: [],
        total: 0,
        nextpage: "",
    };
    private loaded = false;
    private date = (Vue as any).moment().format('YYYY-MM-DD');

    private contestPagination: IContestPagination = {
        nextPlayerPage: null,
        isLastPage: false,
        canFetchMore: true,
        loading: true,
    };

    private async fetchContests() {
        if (!this.contestPagination.canFetchMore) {
            return;
        }

        this.contestPagination.loading = true;
        // @ts-ignore
        const contestsData = await contestService.fetchHistory(this.userId, this.date, this.contestPagination.nextPlayerPage);
        this.contestPagination.nextPlayerPage = contestsData.nextpage;

        if (!contestsData.nextpage) {
            this.contestPagination.isLastPage = true;
            this.contestPagination.canFetchMore = false;
        }

        const items: any[] = contestsData.items;
        this.list = {...this.list, items: [...this.list.items, ...items]};
        this.contestPagination.loading = false;
    }

    async mounted() {
        await this.fetchContests();
        this.loaded = true;
    }
}
